// utils
import { addZero } from 'utils';

// constants
import { DEFAULT_DATE_FORTMAT, DEFAULT_TIMEZONE } from '../constants/const';

//library
import dayjs, { type Dayjs } from 'dayjs';

export function formatDateSaudiToString(date: Date): Date | undefined {
  //객체 + 유효날짜인지 유효성검사
  if (!(date instanceof Date) || !dayjs(date).isValid()) return;

  // 사우디 날짜
  const saudiDate = dayjs(date).tz(DEFAULT_TIMEZONE);
  return saudiDate.toDate();
}

export function formatDateToString(date: Date): Date | undefined {
  //객체 + 유효날짜인지 유효성검사
  if (!(date instanceof Date) || !dayjs(date).isValid()) return;

  // 사우디 날짜
  const saudiDate = dayjs(date).tz(DEFAULT_TIMEZONE);
  return saudiDate.toDate();
}

export function dateToString(date: Date | string): string {
  return dayjs(date).format(DEFAULT_DATE_FORTMAT);
}

export const formatTimeToString = (date: Date): string => {
  let localHour = date.getHours();
  let localMinute = date.getMinutes();

  let amPm: string;
  if (localHour >= 0 && localHour < 12) {
    amPm = 'AM';
  } else {
    amPm = 'PM';
    if (localHour > 12) {
      localHour -= 12;
    }
  }

  return `${String(localHour).padStart(2, '0')}:${String(localMinute).padStart(2, '0')} ${amPm}`;
};

export const formatDateToStringForEntry = (): string => {
  // 현재 날짜와 시간을 UTC로 가져옵니다.
  const currentUTCDate = new Date();
  // 사우디 아라비아 시간대의 오프셋 (+3)을 적용합니다.
  const saudiArabiaOffset = 3 * 60; // 분 단위로 변환
  const date = new Date(currentUTCDate.getTime() + saudiArabiaOffset * 60000);

  // 사우디 아라비아 현지 시간 적용
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth() + 1;
  const dayOfMonth = date.getUTCDate();
  let localHour = date.getUTCHours();
  let localMinute = date.getUTCMinutes();

  return `Update : ${year}-${addZero(month)}-${addZero(dayOfMonth)} ${addZero(
    localHour
  )}:${addZero(localMinute)}`;
};

export const formattedDateEn = (date: Date | string | Dayjs): string => {
  return dayjs(date).locale('en').format('dddd, D MMMM YYYY');
};

export const formattedDateEnShortAndHy = (date: Date | string): string => {
  return dayjs(date).locale('en').format('D-MMM-YYYY');
};

export const formattedDateEnShort = (date: Date | string): string => {
  return dayjs(date).locale('en').format('D MMM YYYY');
};

export const formattedDateEnDay = (date: Date | string): string => {
  const dayName = dayjs(date).format('ddd');
  const dayOfMonth = dayjs(date).format('D');

  return `${dayName} \n ${dayOfMonth}`;
};
